import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { FeeStatus } from './fee-status.enum';
import { FeeType } from './fee-type.enum';
import { Fee, FeeSchema } from './fee.entity';

export const CalculatedFeeSchema = z
    .object({
        fee: FeeSchema,
        feeAmount: z.number(),
        feeStatus: EnumSchema(FeeStatus),
        type: EnumSchema(FeeType),
    })
    .strict();

export class CalculatedFee extends FromSchema(CalculatedFeeSchema) {
    fee: Fee;
    feeAmount: number;
    feeStatus: FeeStatus;
    type: FeeType;
}
